import { useMemo } from "react";
import { useGetNotificationQuery } from "../store/api/notificationApiSlice";
import {
  mergeNavbarNotifications,
  NAVBAR_NOTIFICATION_QUERY,
  parseNotificationList,
} from "../utils/notificationHelpers";

const NAVBAR_POLL_MS = 20000;

/**
 * Navbar zil ikonu: inbox API (kalıcı) + FCM canlı kuyruk.
 * Mesaj rozeti ayrıdır (unreadTotal); burada karıştırılmaz.
 */
export function useNavbarNotifications({ enabled, liveNotifications = [] }) {
  const { data } = useGetNotificationQuery(NAVBAR_NOTIFICATION_QUERY, {
    skip: !enabled,
    pollingInterval: NAVBAR_POLL_MS,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
    refetchOnReconnect: true,
  });

  const inboxList = useMemo(() => parseNotificationList(data), [data]);

  const menuList = useMemo(
    () => mergeNavbarNotifications(liveNotifications, inboxList),
    [liveNotifications, inboxList]
  );

  const unreadCount = enabled
    ? inboxList.length
    : liveNotifications?.length || 0;

  return { menuList, unreadCount };
}
